import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, radius } = redesignTheme;

export const useIAChatWelcomeStyles = makeStyles(() => ({
  welcomeSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    alignItems: 'flex-start',
  },
  welcomeText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 'normal',
    color: colors.text,
    margin: 0,
    whiteSpace: 'nowrap',
  },
  predefinedQueries: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'flex-start',
    width: '100%',
  },
  predefinedQueryButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
    width: 'fit-content',
    maxWidth: '100%',
    padding: '12px 16px',
    borderRadius: radius.md,
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'opacity 0.2s ease',
    '&:hover:not(:disabled)': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  predefinedQueryButtonWide: {
    maxWidth: 272,
  },
  predefinedQueryTitle: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    color: colors.white,
    whiteSpace: 'nowrap',
  },
  predefinedQuerySubtitle: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    color: colors.white,
    whiteSpace: 'nowrap',
  },
  predefinedQuerySubtitleWrap: {
    whiteSpace: 'normal',
  },
}));
